/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { CurrentConfigurationDto } from '../models/current-configuration-dto';
import { getCurrentConfiguration } from '../fn/current-configuration/get-current-configuration';
import { GetCurrentConfiguration$Params } from '../fn/current-configuration/get-current-configuration';

@Injectable({ providedIn: 'root' })
export class CurrentConfigurationApi extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getCurrentConfiguration()` */
  static readonly GetCurrentConfigurationPath = '/v0/currentConfiguration';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getCurrentConfiguration()` instead.
   *
   * This method doesn't expect any request body.
   */
  getCurrentConfiguration$Response(params?: GetCurrentConfiguration$Params, context?: HttpContext): Observable<StrictHttpResponse<CurrentConfigurationDto>> {
    return getCurrentConfiguration(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getCurrentConfiguration$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getCurrentConfiguration(params?: GetCurrentConfiguration$Params, context?: HttpContext): Observable<CurrentConfigurationDto> {
    return this.getCurrentConfiguration$Response(params, context).pipe(
      map((r: StrictHttpResponse<CurrentConfigurationDto>): CurrentConfigurationDto => r.body)
    );
  }

}
